import { ApolloClient, InMemoryCache, from, HttpLink } from '@apollo/client';
import { authLink } from './links/authLink';
import { errorLink } from './links/errorLink';
import { API_BASE_URL } from '../constants/env';

const httpLink = new HttpLink({
  uri: API_BASE_URL,
  credentials: 'same-origin',
});

const link = from([authLink, errorLink, httpLink]);

export const apolloClient = new ApolloClient({
  link,
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          orders: {
            keyArgs: ['filter', 'sortBy'],
            merge(existing = [], incoming = []) {
              // Backend returns a plain list for orders, not a Relay connection.
              // Replace cached list with latest incoming list to avoid edge-based merge errors.
              if (!Array.isArray(incoming)) {
                return Array.isArray(existing) ? existing : [];
              }
              return incoming;
            },
          },
        },
      },
    },
  }),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
    },
    query: {
      fetchPolicy: 'network-only',
      errorPolicy: 'all',
    },
    mutate: {
      errorPolicy: 'all',
    },
  },
  connectToDevTools: import.meta.env.DEV,
});
